import * as React from "react";

import classNames from "classnames";

import "./button.scss";

export interface ILinkButtonProps {
  buttonText: string;
  id?: string;
  layout?: "primary" | "secondary";
  href?: string;
  target?: string;
  rel?: string;
}

export const LinkButton = (props: ILinkButtonProps) => {
  const classes: string = classNames({
    "link-btn": true,
    btn: true,
    [`btn--${props.layout ?? "primary"}`]: true
  });

  return (
    <a href={props.href} id={props.id} className={classes} target={props.target} rel={props.rel}>
      {props.buttonText}
    </a>
  );
};
